import { useState, useEffect } from 'react'
import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type FacultyFormType = {
    userID?: number | null
    nameTH: string
    nameEN: string
    recID: number | null
}

export const useSettingFaculty = (id?: string) => {
    const [settingFaculty, setSettingFaculty] = useState<FacultyFormType>()

    useEffect(() => {
        id && getSettingFaculty(id)
    }, [])

    const callApi = useCallApi()

    const getSettingFaculty = async (facultyID: string) => {
        const { data } = await callApi.axiosGet({
            url: `${umServiceURL.getSettingFaculty}/${facultyID}`,
        })

        setSettingFaculty(data)
        return data
    }

    const putSettingFaculty = async (values: FacultyFormType, facultyID: string) => {
        const { data } = await callApi.axiosPut<any>({
            url: `${umServiceURL.getSettingFaculty}/${facultyID}`,
            params: values,
        })

        return data
    }

    const postSettingFaculty = async (values: FacultyFormType) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServiceURL.getSettingFaculty,
            params: values,
        })

        return data
    }

    return {
        settingFaculty,
        putSettingFaculty,
        postSettingFaculty,
    }
}
